import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/gci/contract-drafts/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/contract-drafts/delete`,
        endpoint: `${endpointBackend}gci/contract-drafts/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Minutas de Contrato',
        labelTitleButtonAdd: 'Incluir nova minuta de contrato',
        fieldsShowOnDelete: ['company'],
        formFilters: !profileFilter.gci_company_id ? filters : null,
        filter: {
            ...profileFilter
        },
        canEdit: false,
        columns: [
            {
                name: 'company',
                label: 'Empresa',
                width: '30%'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            },
            {
                name: 'created_at',
                label: 'Data de Criação',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
